import I18n from 'i18next';
import moment from 'moment';

export { useTranslation, Trans } from 'react-i18next';

export let t = (key, params) => key;

export function initTranslations(t_) {
  t = function () {
    return t_(arguments[0], arguments[1]);
  };
}

export const setMomentLocale = async (language) => {
  try {
    const momentFormatLocale = language.split('-')[0];
    await import(`moment/locale/${momentFormatLocale}.js`);

    moment.locale(momentFormatLocale);
  } catch (error) {
    console.warn(`Failed to load Moment.js locale for ${language}. Falling back to default.`);
    moment.locale('en');
  }
};

export const i18n = I18n;
